import React from "react";
import { Metric } from "./MetricCard.types";
import { Box, Typography } from "@mui/material";

function MetricInfo({ data }: { data: Metric }) {
  const { title, image, value } = data;

  return (
    <Box display="flex" width="100%" alignItems="center" gap={5}>
      {image && (
        <img
          src={data.image}
          alt="metric-info"
          className="metric-image"
          width={52}
          height={52}
        />
      )}
      <Box overflow="hidden" display="flex" flexDirection="column" gap={0.5}>
        <Typography color="grey.100" variant="h2">
          {value}
        </Typography>
        <Typography color="grey.80" variant="label1R">
          {title}
        </Typography>
      </Box>
    </Box>
  );
}

export default MetricInfo;
